---
de:
  news_items:
    attachment: Anhang
    categories:
      findings: Ergebnisse
      landowner: Grundbesitzer
      news: Nachrichten
      other: Andere
      project: Projekt
      report: Bericht
      user_manual: Benutzerhandbuch
    community_access: Benutzer können Community-Beiträge sehen
    community_warning: Community-Beiträge sind für alle Portalbenutzer sichtbar
    create_post: Beitrag erstellen
    edit_post: Beitrag bearbeiten
    filter_all: Alle Beiträge
    filter_category: Nach Kategorie filtern
    filter_community: Community-Beiträge
    filter_internal: Interne Beiträge
    filter_power_plant: Nach Kraftwerk filtern
    flash_delete_error: Konnte nicht gelöscht werden
    hydro_power_news: Wasserkraft-Nachrichten
    image_positions:
      left: Links
      right: Rechts
      top: Oben
    landowner_access_info: Grundeigentümer in diesem Unternehmen und seinen Tochtergesellschaften können diesen Beitrag sehen
    latest_posts: Letzte Beiträge
    markdown_supported: Markdown wird unterstützt
    model_name: Nachrichtenbeitrag
    portfolio_warning: Tochtergesellschaften dieses Unternehmens können diesen Beitrag lesen
    publish: Beitrag erstellen
    save: Beitrag speichern
    search_placeholder: Suche nach Titel, Inhalt oder Autor...
    submit_draft: Als Entwurf speichern
    subsidiaries_warning: Dieser Beitrag ist für alle Portfolio- und Redakteursbenutzer in Tochtergesellschaften der ausgewählten Unternehmen sichtbar (Grundeigentümerzugriff erfordert separates Kontrollkästchen)
    unpublished_draft: Sie haben nicht publizierte Entwürfe
